import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../../utils/Style/component/skeleton.scss';
import TableSkeleton from "./TableSkeleton";
import PaginationSkeleton from "./PaginationSkeleton";

const TransferListSkeleton = () => (
    <div className="my-5">
        <div className="row accountDetail">
            <div className="col-4"></div>
            <div className="col-3"></div>
            <div className="col-4">
                <Skeleton className="account-detail-skeleton" />
            </div>
        </div>
        <TableSkeleton/>
        <div className="row">
                <PaginationSkeleton/>
        </div>

    </div>
);

export default TransferListSkeleton;